import { api } from "./client";

// ── Типове ────────────────────────────────────────────────────────────────────

export interface CompanyBank {
  id: number;
  bank_name: string;
  bic: string;
  iban: string;
  is_default: boolean;
}

export interface CompanyBankInput {
  bank_name: string;
  bic: string;
  iban: string;
  is_default: boolean;
}

export interface Company {
  id: number;
  name: string;
  object_name: string;
  address: string | null;
  mol: string | null;
  eik: string;
  vat_number: string | null;
  phone: string | null;
  email: string | null;
  separate_invoice_numbering: boolean;
  last_invoice_number: number;
  last_proforma_number: string | null;
  is_default: boolean;
  banks: CompanyBank[];
}

export type CompanyPayload = Omit<Company, "id" | "banks"> & {
  banks: CompanyBankInput[];
};

// ── HTTP ──────────────────────────────────────────────────────────────────────

// GET /companies — върнатите фирми са подредени: default първа, после по id.
export const getCompanies = async (): Promise<Company[]> => {
  const response = await api.get<Company[]>("/companies");
  return response.data;
};

// GET /companies/default — текуща фирма; 404 ако още не е създавана.
export const getDefaultCompany = async (): Promise<Company> => {
  const response = await api.get<Company>("/companies/default");
  return response.data;
};

// GET /companies/exists — има ли поне една фирма (само влязъл потребител;
// списъкът иска `manage_companies`). Справките крият „Фискални" при false.
export const getCompaniesExist = async (): Promise<boolean> => {
  const response = await api.get<{ exists: boolean }>("/companies/exists");
  return response.data.exists;
};

export const createCompany = async (data: CompanyPayload): Promise<Company> => {
  const response = await api.post<Company>("/companies", data);
  return response.data;
};

export const updateCompany = async (
  id: number,
  data: CompanyPayload,
): Promise<Company> => {
  const response = await api.put<Company>(`/companies/${id}`, data);
  return response.data;
};

export const deleteCompany = async (id: number): Promise<void> => {
  await api.delete(`/companies/${id}`);
};
